// store for google script loads
// for delayed loading of google script
import { ref } from 'vue';
import { defineStore } from 'pinia';
export const useGoogleScriptStore = defineStore('googleScript', () => {
    const captchaReady = ref(false);
    /**
     * If google recaptcha script is loaded
     * @param bool boolean
     */
    function toggleCaptcha(bool) {
        captchaReady.value = bool;
    }
    const gcalReady = ref(false);
    /**
     * When google calendar script is loaded
     * @param bool boolean
     */
    function toggleGCal(bool) {
        gcalReady.value = bool;
    }
    const googleReady = ref(false);
    /**
     * When google login script is loaded
     * @param bool boolean
     */
    function toggleGoogle(bool) {
        googleReady.value = bool;
    }
    const mapLoaded = ref(false);
    /**
     * When google map script is loaded
     * @param bool boolean
     */
    function toggleMapLoaded(bool) {
        mapLoaded.value = bool;
    }
    return {
        captchaReady,
        toggleCaptcha,
        gcalReady,
        toggleGCal,
        googleReady,
        toggleGoogle,
        mapLoaded,
        toggleMapLoaded
    };
});
